import React from 'react';

import Icons from '../../components/Icons/Icons.js';
import css from './ListingRedesign.module.css';

// DISPLAY DISABLED 2026-09-27 (Jordan): the "Current Special" card is hidden for
// now. The DATA + LOGIC are intentionally kept (publicData.specialActive/
// specialHeadline/specialDetails fields, the owner editor, and the onView proof
// tracking) because "promote a current/limited-time special" is being reserved
// as a FUTURE PAID UPSELL (part of an Optional Upgrades / owner-services
// marketplace). To re-enable the free display, flip SPECIAL_DISPLAY_ENABLED back
// to true (or gate it on a "purchased special upgrade" flag when that ships).
const SPECIAL_DISPLAY_ENABLED = false;

/**
 * SectionSpecialMaybe — owner-promoted "Current Special" card (Haul Star).
 *
 * Renders ONLY when the owner has turned a special on AND set a headline. No
 * transaction runs through BigLoads (contact-direct model intact) — this is a
 * conversion hook that gives the renter a reason to contact the owner NOW.
 *
 * Fires an optional `onView` callback once (mount) so the special becomes a
 * measurable owner proof stat ("does a special lift contact rate?").
 *
 * @param {Object}  publicData  listing.attributes.publicData
 * @param {Function} onView     called once when the card first renders
 */
const SectionSpecialMaybe = ({ publicData = {}, onView }) => {

  const active = publicData.specialActive === true || publicData.specialActive === 'true';
  const headline = (publicData.specialHeadline || '').trim();
  const details = (publicData.specialDetails || '').trim();

  const fired = React.useRef(false);
  React.useEffect(() => {
    // Keep proof tracking gated on the display switch too, so a hidden card never
    // fires phantom "special viewed" events.
    if (!SPECIAL_DISPLAY_ENABLED) return;
    if (!active || !headline) return;
    if (fired.current) return;
    fired.current = true;
    if (typeof onView === 'function') onView();
  }, [active, headline, onView]);

  // Display kill-switch (see note above) — hooks stay unconditional above; we just
  // don't render the card. All data/logic preserved for the future paid upsell.
  if (!SPECIAL_DISPLAY_ENABLED) return null;
  if (!active || !headline) return null;

  return (
    <div className={css.rdSpecialCard}>
      <div className={css.rdSpecialTag}>
        <Icons name="flash" /> Current Special
      </div>
      <h3 className={css.rdSpecialHeadline}>{headline}</h3>
      {details ? <p className={css.rdSpecialDetails}>{details}</p> : null}
    </div>
  );
};

export default SectionSpecialMaybe;
